var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.hatch_een{fill:#265AA5;}\r\n\t.hatch_twee{fill:#FFC5BB;}\r\n\t.st0{fill:#333B3A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "hatch_twee",
    d: "M26.516,21l3-3H30v0.93L27.93,21H26.516z M21,15.93l3-3V12h-0.484L21,14.516V15.93z M24,23.516l-3,3V27 h0.93L24,24.93V23.516z M17.516,18L15,20.516V21h0.93l3-3H17.516z M21,22.516v1.414L26.93,18h-1.414L21,22.516z M18.516,21h1.414 L24,16.93v-1.414L18.516,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hatch_een",
    d: "M30,17h-5v-5c0-0.552-0.448-1-1-1h-1V2c0-0.552-0.448-1-1-1H8C7.696,1,7.409,1.138,7.219,1.375l-4,5 C3.077,6.553,3,6.773,3,7v23c0,0.552,0.448,1,1,1h18c0.552,0,1-0.448,1-1v-2h1c0.552,0,1-0.448,1-1v-5h5c0.552,0,1-0.448,1-1v-3 C31,17.448,30.552,17,30,17z M8,2v5H4L8,2z M22,30H4V8h4c0.552,0,1-0.448,1-1V2h13v9h-1c-0.552,0-1,0.448-1,1v5h-5 c-0.552,0-1,0.448-1,1v3c0,0.552,0.448,1,1,1h5v5c0,0.552,0.448,1,1,1h1V30z M30,21h-6v6h-3v-6h-6v-3h6v-6h3v6h6V21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.4d177d7ca00b9bc4e3831cb68b62ec6a.svg";
export { ForwardRef as ReactComponent };